<template>
  <v-card outlined class="rounded-card">
    <v-card-title class="body-1 font-weight-bold">
      {{ telefoneTitle }}
    </v-card-title>
    <v-card-text class="text--primary">
      <template v-if="!hasTelefones">
        <div class="text-center">
          {{ emptyMessage }}
          <div class="mt-3">
            <v-btn x-small
                   color="primary"
                   class="rounded-tag-small elevation-0 normal-btn-text" @click="addTelefone">
              <v-icon x-small>mdi-plus</v-icon>
              {{  labelTelefoneField }}
            </v-btn>
          </div>
        </div>
      </template>
      <template v-if="hasTelefones">
        <v-list>
          <v-list-item dense
                       v-for="(telefone, i) in fornecedorCadastro.contatosWhatsapp"
                       :key="telefone.$$id">
            <v-list-item-content>
              <v-row dense>
                <v-col cols="12" sm="6">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    autofocus
                    class="required rounded-tag-small"
                    :label="labelTelefoneField"
                    v-mask="mask"
                    maxlength="20"
                    :error="$v.fornecedorCadastro.contatosWhatsapp.$each[i].telefone.$error"
                    @blur="$v.fornecedorCadastro.contatosWhatsapp.$each[i].telefone.$touch()"
                    v-model="telefone.telefone"/>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    autofocus
                    class="rounded-tag-small"
                    label="Nome Contato"
                    maxlength="20"
                    v-model="telefone.nome"/>
                </v-col>
              </v-row>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon @click="remove(i)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-row dense class="text-right">
          <v-col cols="12" class="pr-5">
            <v-btn x-small
                   color="primary"
                   class="rounded-tag-small elevation-0 normal-btn-text" @click="addTelefone">
              <v-icon x-small>mdi-plus</v-icon>
              Telefone
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { uniqueId } from 'lodash';
import validationMixin from '@/mixins/validation-mixin';

export default {
  mixins: [validationMixin],
  props: {
    fornecedorCadastro: {
      type: Object,
      required: true,
    },
    nacional: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    mask() {
      return this.nacional ? ['(##) ####-####', '(##) #####-####'] : ['####################'];
    },
    labelTelefoneField() {
      return 'Telefone';
    },
    telefoneTitle() {
      return 'Telefones';
    },
    emptyMessage() {
      return 'Clique abaixo para adicionar um novo telefone';
    },
    hasTelefones() {
      return this.fornecedorCadastro.contatosWhatsapp.length;
    },
  },
  methods: {
    addTelefone() {
      this.fornecedorCadastro.contatosWhatsapp.push({ $$id: uniqueId(), value: null });
    },
    remove(index) {
      this.fornecedorCadastro.contatosWhatsapp.splice(index, 1);
    },
    validate() {
      return this.validateForm();
    },
  },
  validations: {
    fornecedorCadastro: {
      contatosWhatsapp: {
        $each: {
          telefone: {
            required,
            customMinLength(value) {
              if (!value) return true;
              const len = value.replace(/\D/g, '').length;
              return this.nacional ? len >= 10 : len >= 11;
            },
          },
        },
      },
    },
  },
};
</script>
